import { PropsWithChildren, useCallback, useEffect, useMemo, useState } from 'react';
import { useBooleanState } from '@toss/react';
import { useRouter } from 'next/router';
import { GoogleAnalytics, NaverAnalytics } from '@zep/analytics';
import { ZEM_CHARGE_POPUP_MODE } from '@zep/common/routes';
import { DialogProvider, Toast } from '@zep/dialog';
import { AcceptCookieWrapper } from '@zep/web-components';
import { useChannelTalkBoot } from '../../hooks/useChannelTalkBoot';
import { initSentry } from '../../utils';
import { grantGtmMarketingConsent } from '../../utils/gtmMarketingEvent';
const RootLayout = (props: RootLayoutProps) => {
  const {
    children
  } = props;
  const router = useRouter();
  const [isShowCookiePanel, setShowCookiePanel] = useState(false);
  const [isAllowedAnalytics, allowAnalytics] = useBooleanState(true);
  const enabledCookieAccept = !router.pathname.includes('/web3');
  const isZemChargePopup = useMemo(() => {
    if (!router.pathname.startsWith('/accounts/charge')) return false;
    const queryString = router.asPath.split('?')[1]?.split('#')[0] ?? '';
    return new URLSearchParams(queryString).get('mode') === ZEM_CHARGE_POPUP_MODE;
  }, [router.asPath, router.pathname]);
  // 채널톡 세팅
  useChannelTalkBoot(!isShowCookiePanel && !isZemChargePopup);

  // 쿠키 동의 시 GA 로드와 함께 GTM Consent Mode도 granted로 전환한다.
  // (_document.tsx에서 기본값 denied로 초기화됨)
  const handleAcceptedCookie = useCallback(() => {
    allowAnalytics();
    grantGtmMarketingConsent();
  }, [allowAnalytics]);
  useEffect(() => {
    initSentry();
  }, []);
  return <DialogProvider data-sentry-element="DialogProvider" data-sentry-component="RootLayout" data-sentry-source-file="RootLayout.tsx">
      <AcceptCookieWrapper enabledCookiePanel={enabledCookieAccept} onAcceptedCookie={handleAcceptedCookie} updateVisibilityCookiePanel={setShowCookiePanel} data-sentry-element="AcceptCookieWrapper" data-sentry-source-file="RootLayout.tsx">
        {children}
        <div id="tooltip" />
        <Toast data-sentry-element="Toast" data-sentry-source-file="RootLayout.tsx" />
        {isAllowedAnalytics && <GoogleAnalytics />}
        {isAllowedAnalytics && <NaverAnalytics />}
      </AcceptCookieWrapper>
    </DialogProvider>;
};
export default RootLayout;
type RootLayoutProps = PropsWithChildren;